import React, {useState} from 'react';
import './inputData.css';

export class InputData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            players: ["player 1", "player 2"],
            rounds: 1,
            questions: [],
            question: "", 
            answers: [],
            scores: [],
            gameName: "",
            numAnswers: 2
        }
    }

    renderQuestionInput = (key) => {
        return (<div className="question-input-container">
            <p className="input-data"> Question </p>
            <input
                id="question"
                className="question-input"
                onChange = {this.onChangeUpdateState}
            />
        </div>)
    }
    renderAnswerInput = () => {
        let qs = [];
        for (let i = 0; i < this.state.numAnswers; i++) {
            qs.push(
                <div 
                key={i}
                className="answer-container">
                    <div>
                        <p className="input-data"> Answer </p>
                        <input
                            className="question-input"
                            onChange={this.onChangeUpdateState}
                            id="answers"
                            name={i}
                            key={i}
                        />
                    </div>
                    <div>
                        <p className="input-data"> Score </p>
                        <input
                            className="score-input"
                            onChange={this.onChangeUpdateState}
                            id="scores"
                            name={i}
                            key={i}
                        />
                    </div>
                </div>
            )
        }
        return qs
    }
    onChangeUpdateState = (e) => {
        e.preventDefault();
        console.log(e.target.id);
        this.setState({ [e.target.id]: e.target.value },
        console.log( "Changed", e.target.id))
    }
    renderInputGameName = () => {
        return (
            <div>
                <p className="input-data">game name</p>
                <input className="input-game-name"
                    onChange={this.onChangeUpdateState}
                    id="gameName" />
            </div>)
    }
    renderNumberAnswersSelector = () => {
        return (
            <div>
                <p className="input-data">No. of answers</p>
                {this.renderSelectButtons()}
            </div>
        )
    }
    handleNumAnswersClick = (e) => {
        e.preventDefault();
        let arr = [];
        console.log(this.state.answers.length)
        if (this.state.answers.length == 0){
            for (let i=0; i < e.target.value; i++){
                arr.push("");
            }
        }
        this.setState({answers:arr, numAnswers:e.target.value}, console.log(this.state.answers));
       
    }
    renderSelectButtons = () => {
        let i = 0;
        let vals = [];
        for (i = 2; i <= 8; i++) {
            if (this.state.numAnswers == i) {
                vals.push(<button
                    onClick={(e)=>{this.handleNumAnswersClick(e)}}
                    className="selected"
                    key={i}
                    value={i}
                    id="numAnswers"
                >
                    {i}
                </button>)
            } else {
                vals.push(<button
                    onClick={(e)=>{this.handleNumAnswersClick(e)}}
                    key={i}
                    id="numAnswers"
                    value={i}
                >
                    {i}
                </button>)
            }
        }
        return vals
    }
    renderPlayerNameInput = ()=>{
        return <div>
            <div>
            <p> Player 1</p>
            <input
            className="question-input"
            id="playerName"
            />
            </div>
            <div>
            <p> Player 2</p>
            <input
            className="question-input"
            
            />
            </div>
        </div>
    }
    render() {
        return (
            <div className="input-data-container">
                <h1> Input Data </h1>
                {this.renderInputGameName()}
                {this.renderNumberAnswersSelector()}
                {this.renderQuestionInput()}
                {this.renderAnswerInput()}
            </div>
        )
    }
}